"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTabs = void 0;
var SimpleTabs_1 = require("./SimpleTabs");
Object.defineProperty(exports, "SimpleTabs", { enumerable: true, get: function () { return __importDefault(SimpleTabs_1).default; } });
//# sourceMappingURL=index.js.map